import { makeStyles } from '@material-ui/core/styles';
import { GiftOrderSummaryItemSize } from 'features/dashboard/components/GiftOrderSummaryItem';

interface CheckboxFieldProps {
  size: GiftOrderSummaryItemSize;
}

export const useStyles = makeStyles(theme => ({
  summaryContainer: {
    border: `1px solid #ABAFB3`,
    borderRadius: theme.spacing(10),
    padding: ({ size }: CheckboxFieldProps) => (size === 'medium' ? theme.spacing(15, 15, 20) : theme.spacing(11, 12)),
  },
  totalAvailableContainer: {
    '& p': {
      fontSize: ({ size }: CheckboxFieldProps) => (size === 'medium' ? 22 : 16),
      lineHeight: '18px',
    },
  },
  totalAvailableAmount: {
    textTransform: 'uppercase',
  },
}));
